export const LEAD_CAPTURE_FORM = {
  BLOCKED_LOCALES: ['cn'],
}
